/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu';
import { LinqService, QueryOptions } from 'linquest';
import {
  EmployeeComparisonGroupBulkRequestDto,
  EmployeeComparisonGroupDto,
} from './models';

/**
 * EmployeeComparisonGroupApi - API class
 */
export class EmployeeComparisonGroupApi extends LinqService {

  /**
   * Creates a new EmployeeComparisonGroupApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: EmployeeComparisonGroupDto, options?: QueryOptions) {
    // create query
    const url = `/EmployeeComparisonGroup/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param employeeComparisonGroupBulkRequestDto 
   */
  addOrUpdateBulk(employeeComparisonGroupBulkRequestDto?: EmployeeComparisonGroupBulkRequestDto, options?: QueryOptions) {
    // create query
    const url = `/EmployeeComparisonGroup/AddOrUpdateBulk`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = employeeComparisonGroupBulkRequestDto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/EmployeeComparisonGroup/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/EmployeeComparisonGroup/GetAsync`;
    let query = this.createQuery<EmployeeComparisonGroupDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/EmployeeComparisonGroup/GetTranslatedAsync`;
    let query = this.createQuery<EmployeeComparisonGroupDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/EmployeeComparisonGroup/List`;
    let query = this.createQuery<EmployeeComparisonGroupDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/EmployeeComparisonGroup/ListTranslated`;
    let query = this.createQuery<EmployeeComparisonGroupDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param employeeComparisonGroupBulkRequestDto 
   */
  removeEmployeeComparisonGroupsBulk(employeeComparisonGroupBulkRequestDto?: EmployeeComparisonGroupBulkRequestDto, options?: QueryOptions) {
    // create query
    const url = `/EmployeeComparisonGroup/RemoveEmployeeComparisonGroupsBulk`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = employeeComparisonGroupBulkRequestDto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: EmployeeComparisonGroupDto, options?: QueryOptions) {
    // create query
    const url = `/EmployeeComparisonGroup/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
